import { Link } from "react-router-dom";
import styles from "./index.module.scss";
import { PlatformId } from "views/page-content/platforms/types";
import { useTranslation, Trans } from "react-i18next";

export const PlatformSubheader = ({
    platformId
}: {
    platformId: PlatformId;
}) => {
    const { t } = useTranslation();

    switch (platformId) {
        case PlatformId.Facebook:
            return <p>{t("platforms:facebook-subheader")}</p>;
        case PlatformId.Youtube:
            return (
                <Trans
                    i18nKey={t("platforms:youtube-subheader")}
                    components={{
                        link1: (
                            <Link
                                to={
                                    "https://support.google.com/youtube/answer/2474026?hl=en&ref_topic=9257984&sjid=8139861282208377633-NA"
                                }
                                title="YouTube Live Streaming & Premieres"
                                className={styles["link"]}
                                target="_blank"
                            />
                        )
                    }}
                />
            );
        default:
            return null;
    }
};
